var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"featured-icon",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setFeatured($event)}}},[_c('i',{class:[_vm.featured ? 'fas' : 'fal', _vm.iconClass, 'fa-star']})])}
var staticRenderFns = []

export { render, staticRenderFns }